<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    let files = [];
    export let accept;
    export let archivo = null;

    $: [archivo] = files;
    $: archivo && dispatch('archivo', archivo);
</script>

<label
    class="flex flex-col items-center w-64 px-4 py-6 tracking-wide text-blue-400
    bg-white border border-blue-400 rounded-lg cursor-pointer hover:bg-blue-400
    hover:text-white"
>
    <svg
        class="w-8 h-8"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
    >
        <path
            d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1
            4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4
            4h3v3h2v-3z"
        ></path>
    </svg>
    <div class="mt-2">
        {#if archivo}
            <div class="text-center break-all">{archivo.name}</div>
        {:else}
            <slot />
        {/if}
    </div>
    <input type="file" class="hidden" bind:files accept="{accept || ''}" />
</label>
